import { makeStyles } from '@material-ui/styles'
import notFoundImage from 'assets/not-found.jpg'

export const useStyles = makeStyles(() => ({
    root: (props: { notFoundImage?: string }) => ({
        display: 'inline-block',
        '&.has-error': {
            // Todo: We should create our own not found image!
            content: `url(${props.notFoundImage || notFoundImage})`,
        },
    }),
}))
